import React from "react";

import Tabs  from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import AppBar from "@mui/material/AppBar";
import Icon from "@mui/material/Icon";


const TabsBar = ({tabValue, tabsOrientation, handleSetTabValue, tabs}) => {
    return <AppBar position="static">
        <Tabs orientation={tabsOrientation} value={tabValue} onChange={handleSetTabValue}>
            {
                tabs?.map(({label, icon}) => <Tab key={label}
                                                 label={label}
                                                 icon={<Icon fontSize="small" sx={{mt:0.75}}>{icon}</Icon>}
                />)
            }
        </Tabs>
    </AppBar>
}

export default TabsBar;